// extracted by mini-css-extract-plugin
export default {"licence":"MbC2jUGAC_Qk0NJxdTvB"};